/** Enum that specifies which type of address should be used for the search */
export const AddressEntityType = {
    /**
     * Search for a city only
    */
    "CITY": "CITY",

    /**
     * Search for a country only
    */
    "COUNTRY": "COUNTRY",

    /**
     * Search for a country subdivision only (region, state, province, etc.)
    */
    "COUNTRY_SUBDIVISION": "COUNTRY_SUBDIVISION",

    /**
     * Search for a country subdivision level 1 only (department, etc.)
    */
    "COUNTRY_SUBDIVISION_1": "COUNTRY_SUBDIVISION_1"
};

export const AdvertisingPartnerType = {
    "BLABLACAR": "BLABLACAR",
    "BLABLACAR_DAILY": "BLABLACAR_DAILY",
    "BOOKING": "BOOKING",
    "SECURITE_ROUTIERE": "SECURITE_ROUTIERE",
    "SNCF_CONNECT": "SNCF_CONNECT",
    "TURO": "TURO"
};

export const AvailabilityStatusCode = {
    "AVAILABILITY_ERROR": "AVAILABILITY_ERROR",
    "AVAILABILITY_OK": "AVAILABILITY_OK"
};

export const BookingPlatform = {
    "ANDROID": "ANDROID",
    "ANDROID_TABLET": "ANDROID_TABLET",
    "IOS": "IOS",
    "IPAD": "IPAD",
    "WEB_DESKTOP": "WEB_DESKTOP",
    "WEB_MOBILE": "WEB_MOBILE",
    "WEB_TABLET": "WEB_TABLET"
};

/** CarEnergy types are the same as in the cars csv */
export const CarEnergy = {
    "BIFUEL": "BIFUEL",
    "CNG": "CNG",
    "DIESEL": "DIESEL",
    "ELECTRIC": "ELECTRIC",
    "ETHANOL": "ETHANOL",
    "GASOLINE": "GASOLINE",
    "HYBRID": "HYBRID",
    "HYDROGEN": "HYDROGEN",
    "LPG": "LPG"
};

export const CarType = {
    "CITY": "CITY",
    "COMPACT": "COMPACT",
    "SALOON": "SALOON",
    "SPORTS": "SPORTS",
    "SUV": "SUV"
};

export const ClimateLawType = {
    "CARPOOL": "CARPOOL",
    "HIGHWAY_ITINERARY": "HIGHWAY_ITINERARY",
    "PUBLIC_TRANSPORT": "PUBLIC_TRANSPORT",
    "SHORT_ITINERARY": "SHORT_ITINERARY"
};

/** The type of connectors
For more information, see https://www.power-sonic.com/blog/ev-charging-connector-types/ */
export const ConnectorType = {
    /**
     * DC fast charging connector mostly used in North America
    Also known as Combo 1
    */
    "CCS1": "CCS1",

    /**
     * DC fast charging connector mostly used in Europe
    Also known as Combo 2
    */
    "CCS2": "CCS2",

    /**
     * DC fast charging connector from Japan
    */
    "CHADEMO": "CHADEMO",

    /**
     * AC charging connector mostly used in Europe
    Also known as Type 2
    */
    "MENNEKES": "MENNEKES",

    /**
     * AC charging connector mostly used in France and Italy
    Also known as Type 3
    */
    "SCAME": "SCAME",

    /**
     * Standard household connector
    Low power connector
    */
    "STANDARD_HOUSEHOLD": "STANDARD_HOUSEHOLD",

    /**
     * Tesla specific connector
    */
    "TESLA": "TESLA"
};

export const Currency = {
    "chf": "chf",
    "czk": "czk",
    "dkk": "dkk",
    "eur": "eur",
    "gbp": "gbp",
    "hrk": "hrk",
    "huf": "huf",
    "jpy": "jpy",
    "nok": "nok",
    "pln": "pln",
    "sek": "sek",
    "uah": "uah",
    "usd": "usd"
};

export const Device = {
    "DESKTOP": "DESKTOP",
    "MOBILE": "MOBILE",
    "TABLET": "TABLET"
};

export const DistanceSystem = {
    "IMPERIAL": "IMPERIAL",
    "METRIC": "METRIC"
};

export const DistanceUnit = {
    "FOOT": "FOOT",
    "KILOMETER": "KILOMETER",
    "METER": "METER",
    "MILE": "MILE"
};

export const EVPaymentMethodId = {
    "CASH": "CASH",
    "CREDIT_CARD": "CREDIT_CARD",
    "QR_CODE": "QR_CODE",
    "SERVICE_PROVIDER": "SERVICE_PROVIDER"
};

/** https://www.economie.gouv.fr/dgccrf/carburants-nouvel-etiquetage-europeen-a-pompe */
export const FUEL_TYPE = {
    "B7": "B7",
    "B10": "B10",
    "CNG": "CNG",
    "E5": "E5",
    "E5_98": "E5_98",
    "E10": "E10",
    "E85": "E85",
    "H2": "H2",
    "LPG": "LPG"
};

/** Components */
export const FilterComponentType = {
    "DATE_RANGE": "DATE_RANGE",
    "MULTI_SELECT": "MULTI_SELECT",
    "MULTI_SLIDER": "MULTI_SLIDER",
    "SINGLE_SLIDER": "SINGLE_SLIDER",
    "SWITCH": "SWITCH"
};

export const GetCorridorPoisResultType = {
    "NOT_FOUND": "NOT_FOUND",
    "SUCCESS": "SUCCESS"
};

export const GetPartnersBoxMapsResultResultType = {
    "NOT_FOUND": "NOT_FOUND",
    "SUCCESS": "SUCCESS"
};

export const GetRoadsheetResultType = {
    "NOT_FOUND": "NOT_FOUND",
    "SUCCESS": "SUCCESS"
};

export const GetStaticMapResultType = {
    "NOT_FOUND": "NOT_FOUND",
    "SUCCESS": "SUCCESS"
};

export const ImageAlignment = {
    "bottom": "bottom",
    "top": "top"
};

export const ItineraryConstraint = {
    /**
     * No constraints
    */
    "NONE": "NONE",

    /**
     * No border crossings
    */
    "NO_BORDER_CROSSING": "NO_BORDER_CROSSING",

    /**
     * No ferries
    */
    "NO_FERRY": "NO_FERRY",

    /**
     * No low emission zones
    */
    "NO_LOW_EMISSION_ZONE": "NO_LOW_EMISSION_ZONE",

    /**
     * No motorways
    */
    "NO_MOTORWAY": "NO_MOTORWAY",

    /**
     * No tolls
    */
    "NO_TOLL": "NO_TOLL",

    /**
     * No vignettes
    */
    "NO_VIGNETTE": "NO_VIGNETTE"
};

export const ItineraryTrafficMode = {
    "ALL": "ALL",
    "CLOSINGS": "CLOSINGS",
    "NONE": "NONE"
};

export const ItineraryTravelMode = {
    "BIKE": "BIKE",
    "CAR": "CAR",
    "MOTORCYCLE": "MOTORCYCLE",
    "WALK": "WALK"
};

/** Options */
export const OptionId = {
    /**
     * Accommodation equipment
    */
    "ACCES_CHKIN_H24": "ACCES_CHKIN_H24",

    "ANIMALS": "ANIMALS",
    "ARAL": "ARAL",
    "AUTO_WASH": "AUTO_WASH",

    /**
     * Accommodation type
    */
    "BB": "BB",

    /**
     * Restaurant distinction
    */
    "BIB_GOURMAND": "BIB_GOURMAND",

    "BP": "BP",
    "BREAKFAST": "BREAKFAST",
    "CAMPING": "CAMPING",
    "CCS_COMBO": "CCS_COMBO",
    "CHADEMO": "CHADEMO",
    "DIESEL": "DIESEL",
    "ESSO": "ESSO",
    "ETHANOL": "ETHANOL",
    "E_10": "E_10",
    "FAMILY_ROOM": "FAMILY_ROOM",
    "GPL": "GPL",
    "HOTEL": "HOTEL",
    "INFLATION_STATION": "INFLATION_STATION",
    "MANUAL_WASH": "MANUAL_WASH",
    "MENNEKES": "MENNEKES",
    "METHANE": "METHANE",

    /**
     * Accommodation distinction
    */
    "ONE_KEY": "ONE_KEY",

    "ONE_STAR": "ONE_STAR",

    /**
     * Tourism distinction
    */
    "ONE_STAR_TOURISM": "ONE_STAR_TOURISM",

    /**
     * Gas service equipment
    */
    "OPEN_24_7": "OPEN_24_7",

    "OTHER_NETWORK": "OTHER_NETWORK",
    "PARKING": "PARKING",
    "PARK_ELEC": "PARK_ELEC",
    "POOL": "POOL",
    "PREMIUM_DIESEL": "PREMIUM_DIESEL",
    "REDUCED_MOBILITY": "REDUCED_MOBILITY",
    "RESIDENCE": "RESIDENCE",
    "RESTAURANTS": "RESTAURANTS",
    "SCAME": "SCAME",
    "SELECTED_RESTAURANT": "SELECTED_RESTAURANT",

    /**
     * Gas service network
    */
    "SHELL": "SHELL",

    "SPA": "SPA",

    /**
     * Gas type
    */
    "SP_95": "SP_95",

    "SP_98": "SP_98",

    /**
     * Ev service connector
    */
    "STANDARD_HOUSEHOLD": "STANDARD_HOUSEHOLD",

    "TESLA": "TESLA",
    "THREE_KEYS": "THREE_KEYS",
    "THREE_STARS": "THREE_STARS",
    "THREE_STARS_TOURISM": "THREE_STARS_TOURISM",
    "TOTAL_ENERGIES": "TOTAL_ENERGIES",

    /**
     * Tourism place
    */
    "TOURISM_CITY_PLACE": "TOURISM_CITY_PLACE",

    "TOURISM_CIVIL_MILITARY_PLACE": "TOURISM_CIVIL_MILITARY_PLACE",
    "TOURISM_HISTORICAL_ARCHEOLOGICAL_PLACE": "TOURISM_HISTORICAL_ARCHEOLOGICAL_PLACE",
    "TOURISM_INDUSTRIAL_PLACE": "TOURISM_INDUSTRIAL_PLACE",
    "TOURISM_MUSEUM_PLACE": "TOURISM_MUSEUM_PLACE",
    "TOURISM_NATURE_PLACE": "TOURISM_NATURE_PLACE",
    "TOURISM_PARK_GARDEN_PLACE": "TOURISM_PARK_GARDEN_PLACE",
    "TOURISM_RELIGIOUS_PLACE": "TOURISM_RELIGIOUS_PLACE",
    "TOURISM_WORK_ART_PLACE": "TOURISM_WORK_ART_PLACE",
    "TWO_KEYS": "TWO_KEYS",
    "TWO_STARS": "TWO_STARS",
    "TWO_STARS_TOURISM": "TWO_STARS_TOURISM",
    "TYPE_3C": "TYPE_3C",
    "WIFI": "WIFI"
};

/** The type of POI the API can return */
export const POI_TYPE = {
    "ACCOMMODATION": "ACCOMMODATION",
    "ACCOMMODATION_MICHELIN": "ACCOMMODATION_MICHELIN",
    "PARKING": "PARKING",
    "PARTNER": "PARTNER",
    "PARTNER2": "PARTNER2",
    "RESTAURANT": "RESTAURANT",
    "RESTAURANT_MICHELIN": "RESTAURANT_MICHELIN",
    "REST_STOP": "REST_STOP",
    "SERVICE": "SERVICE",
    "SERVICE_EV": "SERVICE_EV",
    "SERVICE_GAS_STATION": "SERVICE_GAS_STATION",
    "TOURISM": "TOURISM"
};

/** The type of POI that can be queried */
export const POI_TYPE_QUERY = {
    "ACCOMMODATION": "ACCOMMODATION",
    "EV_SERVICE": "EV_SERVICE",
    "PARKING": "PARKING",
    "PARTNER": "PARTNER",
    "PARTNER2": "PARTNER2",
    "RESTAURANT": "RESTAURANT",
    "REST_STOP": "REST_STOP",
    "SERVICE_GAS_STATION": "SERVICE_GAS_STATION",
    "TOURISM": "TOURISM"
};

export const PRICE_CATEGORY = {
    "HIGH": "HIGH",
    "LOW": "LOW",
    "MEDIAN": "MEDIAN"
};

export const PartnerAdContentType = {
    "Media": "Media",
    "Rich": "Rich"
};

/** FilterIds */
export const PoiFilterId = {
    "ACCOMMODATION_AVAILABILITY_DATE_RANGE": "ACCOMMODATION_AVAILABILITY_DATE_RANGE",
    "ACCOMMODATION_EQUIPMENT": "ACCOMMODATION_EQUIPMENT",
    "ACCOMMODATION_MAX_PRICE": "ACCOMMODATION_MAX_PRICE",
    "ACCOMMODATION_PRICE": "ACCOMMODATION_PRICE",
    "ACCOMMODATION_RATE": "ACCOMMODATION_RATE",
    "ACCOMMODATION_STARS": "ACCOMMODATION_STARS",
    "ACCOMMODATION_TYPE": "ACCOMMODATION_TYPE",

    /**
     * Parking
    */
    "BOOKABLE_PARKING": "BOOKABLE_PARKING",

    /**
     * Ev service
    */
    "CONNECTOR": "CONNECTOR",

    /**
     * Rest stop
    */
    "FAMILY_FRIENDLY_REST_STOP": "FAMILY_FRIENDLY_REST_STOP",

    "GAS_STATION_EQUIPMENT": "GAS_STATION_EQUIPMENT",
    "GAS_STATION_LAST_UPDATE": "GAS_STATION_LAST_UPDATE",
    "GAS_STATION_NETWORK": "GAS_STATION_NETWORK",

    /**
     * Service gas station
    */
    "GAS_STATION_TYPE": "GAS_STATION_TYPE",

    "INCLUDE_GREEN_STAR_RESTAURANT": "INCLUDE_GREEN_STAR_RESTAURANT",

    /**
     * Accommodation
    */
    "MICHELIN_ACCOMMODATION": "MICHELIN_ACCOMMODATION",

    "MICHELIN_ACCOMMODATION_DISTINCTION": "MICHELIN_ACCOMMODATION_DISTINCTION",

    /**
     * Restaurant
    */
    "MICHELIN_RESTAURANT": "MICHELIN_RESTAURANT",

    "ONLY_MICHELIN_GUIDE_SELECTION": "ONLY_MICHELIN_GUIDE_SELECTION",
    "OTHER_RESTAURANT_RATE": "OTHER_RESTAURANT_RATE",
    "POWER": "POWER",
    "RESTAURANT_MAX_PRICE": "RESTAURANT_MAX_PRICE",

    /**
     * Tourism
    */
    "TOURISM_MICHELIN_DISTINCTION": "TOURISM_MICHELIN_DISTINCTION",

    "TOURISM_TYPE_PLACES": "TOURISM_TYPE_PLACES"
};

export const REST_STOP_VARIANT = {
    "REST": "REST",
    "SERVICE": "SERVICE"
};

export const REVIEW_MENTION = {
    "BAD": "BAD",
    "DISAPPOINTING": "DISAPPOINTING",
    "EXCEPTIONAL": "EXCEPTIONAL",
    "FABULOUS": "FABULOUS",
    "GOOD": "GOOD",
    "MEDIOCRE": "MEDIOCRE",
    "PASSABLE": "PASSABLE",
    "PLEASANT": "PLEASANT",
    "QUITE_MEDIOCRE": "QUITE_MEDIOCRE",
    "SUPERB": "SUPERB",
    "VERY_GOOD": "VERY_GOOD",
    "WELL": "WELL"
};

export const ReverseGeocodeResultType = {
    "NOT_FOUND": "NOT_FOUND",
    "SUCCESS": "SUCCESS"
};

export const RouteTrafficMentionColor = {
    "BLACK": "BLACK",
    "ORANGE": "ORANGE",
    "RED": "RED"
};

export const RouteType = {
    "ALTERNATIVE": "ALTERNATIVE",
    "DISCOVERY": "DISCOVERY",
    "ECOLOGICAL": "ECOLOGICAL",
    "ECONOMIC": "ECONOMIC",
    "QUICKEST": "QUICKEST",
    "SHORTEST": "SHORTEST"
};

export const SUB_TYPE = {
    "BB": "BB",
    "CAMPING": "CAMPING",
    "HOTEL": "HOTEL",
    "RESIDENCE": "RESIDENCE"
};

export const SearchAddressEntityType = {
    "CITY": "CITY",
    "COUNTRY": "COUNTRY",
    "COUNTRY_SUBDIVISION": "COUNTRY_SUBDIVISION",
    "COUNTRY_SUBDIVISION_1": "COUNTRY_SUBDIVISION_1"
};

export const SearchAdvertisingPartnersResultType = {
    "NOT_FOUND": "NOT_FOUND",
    "SUCCESS": "SUCCESS"
};

export const SearchGYGActivitiesResultType = {
    "ACTIVITIES_FOUND": "ACTIVITIES_FOUND",
    "NOT_FOUND": "NOT_FOUND",
    "NO_ACTIVITY_FOUND_WITHOUT_REGION_DATA": "NO_ACTIVITY_FOUND_WITHOUT_REGION_DATA",
    "NO_ACTIVITY_FOUND_WITH_REGION_DATA": "NO_ACTIVITY_FOUND_WITH_REGION_DATA"
};

export const SearchGetYourGuideToursResultType = {
    "TOURS_FOUND": "TOURS_FOUND",
    "TOURS_NOT_FOUND": "TOURS_NOT_FOUND",
    "TOURS_NOT_FOUND_WITHOUT_REGION_DATA": "TOURS_NOT_FOUND_WITHOUT_REGION_DATA",
    "TOURS_NOT_FOUND_WITH_REGION_DATA": "TOURS_NOT_FOUND_WITH_REGION_DATA"
};

export const SearchItineraryResultType = {
    "NOT_FOUND": "NOT_FOUND",
    "SUCCESS": "SUCCESS"
};

export const TrafficInformationType = {
    "ACCIDENT": "ACCIDENT",
    "INCIDENT": "INCIDENT",
    "ROAD_CLOSED": "ROAD_CLOSED",
    "ROAD_WORKS": "ROAD_WORKS",
    "SHRINKING": "SHRINKING",
    "WEATHER": "WEATHER"
};

export const DedupeMatchMode = {
    "Variables": "Variables",
    "Operation": "Operation",
    "None": "None"
};